import React, { FC } from 'react';
import { Select as AntdSelect, Form } from 'antd';
import { SelectProps, OptionProps } from 'antd/lib/select';
import useFormInstance from 'antd/lib/form/hooks/useFormInstance';

export const Select: FC<(SelectProps | OptionProps) & { name?: string; isOption?: boolean }> = (props) => {
  const form = Form.useFormInstance();

  // Workaround because Antd Select does not support form name and the devs are stubborn
  // https://github.com/ant-design/ant-design/issues/36489

  if (props.isOption) {
    return <AntdSelect.Option {...props}>{props.children}</AntdSelect.Option>;
  }

  if (props.name) {
    const { name, ...rest } = props;
    const onChange = (value: any) => {
      form.setFieldsValue({ [name]: value });
      if (props.onChange) {
        props.onChange(value);
      }
    };
    return <AntdSelect {...rest} onChange={onChange} />;
  }

  return <AntdSelect {...props} />;
};
export default Select;
